import { TIPOLOGIE_IMPIANTO, type TipologiaImpianto } from '@praticheenergia/domain'

/**
 * `non_configurato` e uno stato di transito degli import, mai una scelta
 * dell'utente. `impianto_vendita` compare solo per i partner con il flag
 * venditore (0001: partner.venditore).
 */
export function tipologieDisponibili(venditore: boolean): TipologiaImpianto[] {
  return TIPOLOGIE_IMPIANTO.filter((t) => {
    if (t === 'non_configurato') return false
    if (t === 'impianto_vendita') return venditore
    return true
  })
}
